<template>
  <div :class="$style.base">
    <div :class="$style.name">
      <BaseText type="small" color="white">
        {{ getTitle }}
      </BaseText>
      <BaseText type="bold" color="white">
        {{ technician.firstName }}
      </BaseText>
    </div>
    <div :class="$style.pictureWrapper">
      <img :class="$style.picture" :src="getTechnicianPicture" crossorigin="use-credentials">
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { computed } from 'vue'
import BaseText from '~/base/components/text/Text.vue'
import { PrefixType, getGenderedTechnician } from '~/base/utils/gender'
import type { Technician } from '~/base/types/technician/technician'

const props = defineProps({
  technician: { type: Object as PropType<Technician>, required: true }
})

const getTechnicianPicture = computed((): string => {
  return props.technician.picture
})

const getTitle = computed((): string => {
  return getGenderedTechnician(props.technician, PrefixType.YOUR)
})
</script>

<style module>
.base {
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: -24px;
  margin-left: -24px;
  margin-right: -24px;
  margin-bottom: 24px;

  @media screen and (min-width: 740px) {
    margin-top: -36px;
    margin-left: -140px;
    margin-right: -141px;
    margin-bottom: 36px;
  }
}

.name {
  background-color: var(--color-lightturquoise);
  color: var(--color-white);
  padding: 95px 12px;
  flex-basis: 40%;
  @media screen and (min-width: 740px) {
      padding: 120px 36px;
  }
}

.pictureWrapper {
  flex-basis: 60%;
}

.picture {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
